import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EmpadronamientoCard } from "../UI/EmpadronamientoCard";
import { EmpadronamientoDetalleSolicitudInformation } from "./EmpadronamientoDetalleSolicitudInformation";
import { setIdTipoEmpadronamiento } from "../../../actions/empadronamiento/Empadronamiento";

export const EmpadronamientoDetalleSolicitud = (props) => {
  const { solicitudSeleccionada = {},idTipoEmpadronamiento} = useSelector(
    (state) => state.empadronamiento
  );

  const dispatch = useDispatch();


  useEffect(() => {
    if (solicitudSeleccionada?.idTipoEmpadronamiento != null) {
      dispatch(setIdTipoEmpadronamiento(solicitudSeleccionada.idTipoEmpadronamiento));
    }
  }, [solicitudSeleccionada?.idTipoEmpadronamiento, dispatch]);


  return (
    <EmpadronamientoCard width={"55%"}>
      {/*showForm ? (
        <EmpadronamientoDetalleTipoForm 
        idTipoEmpadronamiento={idTipoEmpadronamiento}
        fromBandeja = {props.fromBandeja}
        />
      ) : (*/}
        <EmpadronamientoDetalleSolicitudInformation
        idTipoEmpadronamiento={idTipoEmpadronamiento}
        />
      
    </EmpadronamientoCard>
  );
};
